import React from 'react';
import styled from 'styled-components';

import { useColor } from '../../../../../../modules/contexts/Color/useColor';

interface StatusIncorporacaoCellProps {
  value?: string;
}

const StatusBadge = styled.div<{ bgColor: string }>`
  background-color: ${({ bgColor }) => bgColor};
  padding: 8px 4px;
  border-radius: 6px;
  /* font-size: 0.75rem; */
  text-align: center;
  font-weight: 500;
  color: black;
  white-space: nowrap;
`;

export const STATUS_INCORPORACAO_COR: Record<string, string> = {
  Recomendado: 'Status BG - Amarelo',
  Incorporado: 'Status BG - Verde',
  Excluído: 'Status BG - Vermelho',
  'Não Pactuado': 'Status BG - Cinza',
  Pactuado: 'Status BG - Verde',
  'Não atualizado': 'Status BG - Cinza',
  'Em atualização': 'Status BG - Amarelo',
  Atualizado: 'Status BG - Verde',
  Ativo: 'Azul-Atlântico',
};

export const StatusIncorporacaoCell: React.FC<StatusIncorporacaoCellProps> = ({
  value,
}) => {
  const { getHexByNome } = useColor();

  if (!value) return null;

  const nomeCor = STATUS_INCORPORACAO_COR[value] ?? 'Status BG - Cinza';

  const bgColor = getHexByNome(nomeCor, '#dddddddd');

  return <StatusBadge bgColor={bgColor}>{value}</StatusBadge>;
};
